/*
 * Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import {Asset} from './asset.model';
import {PropertyBinding} from './property-binding.model';
import { Role } from './role.model';
import {Location} from './location.model';

export class Point {
    label: string;
    iri: string;
    asset: Asset;
    roleAssigned: boolean;
    confidence: string;
    comment: string;
    unitLabel: string;
    bindings: Array<PropertyBinding>;
    roles: Array<Role>;
    location: Location;
}
